import React, { useState, useEffect, useRef, useMemo } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TextField from "@mui/material/TextField";
import ChatComponent from "./ChatComponent";
import Popover from "@mui/material/Popover";
import List from "@mui/material/List";
import BlockIcon from "@mui/icons-material/Block";
import ListItemText from "@mui/material/ListItemText";
import RefreshIcon from "@mui/icons-material/Refresh";
import Badge from "@mui/material/Badge";
import ListItem from "@mui/material/ListItem";
import { MoreVert, Visibility } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import AcceptRequestDialog from "./Dialouge";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { formatDate } from "../../utils/helperFunction";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import SideNavone from "../../SideNavBar";
import Button from "@mui/material/Button";
import CallComponent from "./VideoCall";
import "./customStyle.css";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { useLocation } from "react-router-dom";
import { Grid, IconButton, Typography } from "@mui/material";
import apiServices, { axiosInstance } from "../../services/apiServices";
import { useCallback } from "react";
import ButtonGroup from "@mui/material/ButtonGroup";
import CustomizedSnackbars from "./CustomSnackbar";
import { v4 as uuidv4 } from "uuid";
// import useConnectSocket from "./useConnectSocket";
import {
  connectSocket,
  disconnectSocket,
  getSocket,
} from "../../services/socketService";
// import useConnectSocket from "./useConnectSocket";
import generateDeviceId from "./utils/generateDeviceId";
import AddHeaderText from "./components/FriendComponents/AddHeaderText";
import AddManageButton from "./components/FriendComponents/AddManageButton";
import SearchBar from "./components/FriendComponents/SearchBar";
import ManageFriendRequests from "./components/FriendComponents/ManageFriendRequests";
import styles from "./Style/Managebutton.module.css";
import AddFriend from "./components/FriendComponents/AddFriend";
import AddFriendButton from "./components/FriendComponents/AddFriendButton";
import CustomBadge from "../../Assets/components/Avatar/Badge/Badge";
import StatusBadge from "./components/StatusBadge";
import BuzzSideNav from "./BuzzSideNav";
import { useDispatch, useSelector } from "react-redux";
import { IoArrowBack } from "react-icons/io5";
import {
  chatClickedInCallAction,
  chatOpenAction,
  fetchContactsRequest,
  onlineUsersAction,
  presentScreen,
  selectedChatAction,
  setCallUserAction,
  setSnackbarAction,
  updateContacts,
} from "../../Store/Buzzcom/actions";
import SideBarHeader from "../../SideNavBar/SideBarHeader";
import { checkMediaDevicesAndPermissions } from "./utils/checkResourcesAndPermissions";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import Snackbar from "./Snackbar";

const MessageScreen = () => {
  const contacts = useSelector((state) => state.Buzzcom.contacts);
  const alluserdata = useSelector((state) => state.Buzzcom.userDetail);
  const selectedChat = useSelector((state) => state.Buzzcom.selectedChat);
  // const [selectedChat, setSelectedChat] = useState(null);
  const chatClickedInCall = useSelector(
    (state) => state.Buzzcom.chatClickedInCall
  );
  const callUser = useSelector((state) => state.Buzzcom.callUser);
  const dispatch = useDispatch();
  const [popUp, setPopup] = useState(false);
  const chatOpen = useSelector((state) => state.Buzzcom.chatOpen);
  const [hasMounted, setHasMounted] = useState(false);
  const [videoSwitch, setVideoSwitch] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const candidateArrayRef = useRef([]);
  const [comingCandidateArray, setComingCandidateArray] = useState([]);
  const [isRemoteSet, setIsRemoteSet] = useState(false);
  const [contactDelete, setContactDelete] = useState(null);
  const [trueIdsArray, setTrueIdsArray] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openPop = Boolean(anchorEl);
  const id = openPop ? "simple-popover" : undefined;
  const [popUpAdd, setPopupAdd] = useState(false);
  const [isInCall, setIsInCall] = useState(false);

  const [callAccepted, setCallAccepted] = useState({
    accepted: false,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [addFriendClick, setAddFriendClick] = useState(false);

  const [incomingCall, setIncomingCall] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [outgoingCall, setOutgoingCall] = useState(false);
  const [loader, setLoader] = useState(false);
  const pc = useRef();
  const [chatting, setChatting] = useState(false);
  const [contactsRefresh, setContactsRefresh] = useState(false);
  const [contactsSwitch, setContactsSwitch] = useState(false);
  const [accept, setAccept] = useState({
    conversationId: "",
    requestedBy: "",
  });
  const onlineUsers = useSelector((state) => state.Buzzcom.onlineUsers);
  const [sender, setSender] = useState("");
  const [addedContactIds, setAddedContactIds] = useState([]);
  const [receiver, setReceiver] = useState("");
  const [caller, setCaller] = useState({
    id: null,
    name: null,
    offer: null,
    callSender: null,
    callRec: null,
    type: null,
    hasVideo: null,
    fromDeviceId: null,
  });
  const [call, setCall] = useState({
    audio: false,
    video: false,
  });
  const [camOff, setCamOff] = useState({
    my: false,
    other: false,
  });
  const [platformCall, setPlatformCall] = useState("");
  const handleCall = useSelector((state) => state.Buzzcom.handleCall);
  let rtcPeerConnectionCount = 0;
  const localVidRef = useRef(null);
  const audioElementRef = useRef(null);
  const [manageRequestClicked, setManageRequestClicked] = useState(false);
  const remoteVidRef = useRef(null);
  const [myStream, setMyStream] = useState();
  const [muteStatus, setMuteStatus] = useState(false);
  const [blockStatus, setBlockStatus] = useState(false);
  const [deviceToken, setDeviceToken] = useState(null);
  const [popUpBlock, setPopupBlock] = useState(false);
  const [popUpBlockDelete, setPopUpBlockDelete] = useState(false);
  const [remoteStream, setRemoteStream] = useState();
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userIdsArray, setUserIdsArray] = useState([]);
  const [userBusy, setUserBusy] = useState(false);
  const [activeButton, setActiveButton] = useState("sent");
  const [selectedChatBlocked, setSelectedChatBlocked] = useState(false);
  const [deviceId, setDeviceId] = useState(null);
  const [otherCallerDeviceId, setOtherCallerDeviceId] = useState(null);
  const [isView, setIsView] = useState(false);
  const socketRef = useRef(null);
  const contactsRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const [acceptAddContact, setAcceptAddContact] = useState(false);

  // TEST =---------------------------------------------------------
  useEffect(() => {
    dispatch(presentScreen("Messages"));
  }, []);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("user"));
        console.log("userid...", userData);

        // let response = await apiServices.getUserById(userData.result.users.id);

        // Update state with user data
        setUserId(userData?.id);
        setUserName(userData?.firstName + " " + userData?.lastName);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchData();
    return () => {
      // Optional cleanup
    };
  }, []);

  // Second useEffect for socket connection, now with userId dependency
  useEffect(() => {
    if (!userId) return; // If userId is not set, do nothing
    console.log("connected socketRef.current 2");
    const initializeSocketConnection = async () => {
      try {
        const getDeviceId = await generateDeviceId();
        setDeviceId(getDeviceId);
        // Connect the socket using userId and generated deviceId
        socketRef.current = await connectSocket(userId, getDeviceId);
        console.log("Socket is ready to use:", socketRef.current);
        setIsConnected(true);
      } catch (error) {
        console.error("Failed to connect socket:", error);
      }
    };
    initializeSocketConnection();
    const handleBeforeUnload = () => {
      // socketRef.current.disconnect();
      apiServices.sendCallEnded({
        from: userId,
        fromDeviceId: deviceId,
      });
      console.log("socketRef.current disconnected due to tab/window closing.");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      if (socketRef.current) {
        socketRef.current.disconnect(); // Properly disconnect the socket on cleanup
        socketRef.current = null;
      }
    };
  }, [userId]); // Add userId to the dependency array

  const callEndCall = (caller) => {
    try {
      console.log("callerInfo>>>", caller);
      setCamOff({ my: false, other: false });
      setVideoSwitch(false);
      setOutgoingCall(false);
      // setCallEnded(true);
      setCallAccepted({ accepted: false });
      // pc.current.close();
      console.log("PC>>>END", pc.current);

      if (localVidRef.current !== null && localVidRef.current !== undefined) {
        localVidRef.current?.srcObject
          ?.getTracks()
          ?.forEach((track) => track.stop());
        localVidRef.current.srcObject = null;
      }

      if (remoteVidRef.current && remoteVidRef.current.srcObject) {
        remoteVidRef.current?.srcObject
          ?.getTracks()
          ?.forEach((track) => track.stop());
        remoteVidRef.current.srcObject = null;
      }
      if (caller?.hasVideo) {
        setCall({ audio: false, video: false });
      } else {
        setCall({ audio: false });
      }
      setIsRemoteSet(false);
      setLoaded(true);
      if (pc.current) {
        pc.current.onicecandidate = null;
        pc.current.ontrack = null;
        pc.current.onconnectionstatechange = null;
        pc.current.close();
        pc.current = null;
        rtcPeerConnectionCount--;
      }
      dispatch(setCallUserAction(null));
      // window.location.reload();

      // pc.current.close();
      // console.log("CLOSED_PEER_CONNECTION", pc.current);
      // pc.current = null;
      // initializedRTCPeerConnection();
      // }
      apiServices.sendCallEnded({
        from: userId,
        fromDeviceId: deviceId,
      });
    } catch (err) {
      console.log("Error in callNavigator", err);
      callResponse("error", err.message);
    }
  };

  const [Ids, setIds] = useState("");

  // useEffect(() => {
  //   const fetchFingerprint = async () => {
  //     const fp = await FingerprintJS.load();
  //     const result = await fp.get();
  //     setIds(result.visitorId);
  //   };

  //   fetchFingerprint();
  // }, []);

  // console.log("ids is", Ids);

  console.log("isConnected@@", isConnected);

  useEffect(() => {
    console.log("DATA>>>CONTA3", isConnected);
    let alreadyListened = false;
    if (!socketRef.current) return;
    if (!alreadyListened) {
      alreadyListened = true;

      socketRef.current.on("new-contact-request", (message) => {
        if (message?.to == userId && message?.type == "newContact") {
          console.log("new-contact-reques:", message);
          setContactsRefresh(true);
        } else if (message?.to == userId && message?.type == "acceptContact") {
          dispatch(fetchContactsRequest(userId));
        }

        // setChatting(true);
        // Update the UI with the message
      });
      socketRef.current.on("contactDelete", (message) => {
        console.log("contactDelete:", message);
        if (message?.to == userId) {
          setContactsRefresh(true);
        }

        // setChatting(true);
        // Update the UI with the message
      });
      // socketRef.current.on("online-users", (message) => {
      //   // Check if message is an array before using map
      //   if (Array.isArray(message)) {
      //     const userIdsArray = message
      //       .map((obj) => obj.userId) // Extract userIds
      //       .filter(
      //         (userId) =>
      //           userId !== undefined && userId !== null && userId !== "null"
      //       ); // Filter out undefined or null values

      //     // Store userIdsArray in the local storage
      //     console.log("onlineeeeeeeeeeeeee", JSON.stringify(userIdsArray));
      //     setUserIdsArray(JSON.parse(JSON.stringify(userIdsArray)))
      //   } else {
      //     console.error(
      //       'Received "online-users" message is not an array:',
      //       message
      //     );
      //     // Handle the error or log it as needed
      //   }
      // });
      socketRef.current.on("prv_typing_message", (message) => {
        console.log("prv_typing_message", message);
        if (sender && receiver) {
          if (
            (message.typing === "typing" &&
              message.from == receiver &&
              message?.to == sender) ||
            (message.typing === "typing" &&
              message.from == sender &&
              message?.to == receiver)
          ) {
            // User is typing
            // if (!isTyping) {
            //   setIsTyping(true); // Update the state to indicate typing
            //   setTimeout(() => {
            //     setIsTyping(false);
            //   }, 3000);
            // }
          }
          // else {
          //   // User stopped typing
          //   if (isTyping) {
          //     setTimeout(() => {
          //       setIsTyping(false);
          //     }, 4000);
          //     // Update the state to indicate not typing
          //   }
          // }
        }
      });

      socketRef.current.on("online-users", (data) => {
        console.log("data##", data);
        const onlineUserIds = !data?.length
          ? []
          : data?.map((__data) => __data.userId);
        dispatch(onlineUsersAction(onlineUserIds));
      });

      socketRef.current.on("mute", (message) => {
        if (message?.to == userId) {
          if (message?.type == "muted") {
            console.log("mute workinf", message);
            setMuteStatus(true);
          } else if (message?.type == "unmuted") {
            console.log("mute workinf", message);
            setMuteStatus(false);
          }
        }

        // Update the UI with the message
      });

      socketRef.current.on("switchContent", (message) => {
        console.log("Switch_Content???", message);
        if (message?.to == userId) {
          if (message?.type == "accepted") {
            setCamOff((prev) => ({ ...prev, other: true, my: true }));
          } else if (message?.type == "camTurnedOn") {
            setCamOff((prev) => ({ ...prev, other: true, my: true }));
          } else if (message?.type == "camTurnedOff") {
            setCamOff((prev) => ({ ...prev, other: false }));
          }
        }
      });

      socketRef.current.on("offer", (message) => {
        console.log("offerReceived", message);
        console.log(pc.current?.connectionState, "isInCall>>>", isInCall);
        if (pc.current?.connectionState === "connected" || isInCall) {
          socketRef.current.emit("disconnectcall", {
            from: message.to,
            to: message.from,
            reason: "User Busy",
            deviceId: message.deviceId,
          });
          // callEndCall();
        } else if (message.to == userId) {
          !pc.current && initializedRTCPeerConnection();
          setOtherCallerDeviceId(message.deviceId);
          let callerInfo = null;

          setCaller((prev) => ({
            ...prev,
            id: message.from,
            offer: message?.offer ? message.offer : message.callerSDP,
            callSender: message.from,
            callRec: message?.to,
            type: message?.type,
            hasVideo: message.hasVideo,
            fromDeviceId: message.deviceId,
          }));

          const concatenatedSenderReceiver = message.from + "." + message.to;
          const concatenatedReceiverSender = message.to + "." + message.from;
          contacts?.forEach((contact) => {
            if (
              contact?.contacts?.length > 1 &&
              message.from == contact.contacts[1].userId
            ) {
              setCaller((prev) => ({
                ...prev,
                name: contact.contacts[1].userName,
              }));
            }

            if (
              contact?.conversationId == concatenatedSenderReceiver ||
              contact?.conversationId == concatenatedReceiverSender
            ) {
              // setSelectedChat(contact);
              dispatch(setCallUserAction(contact));
              dispatch(selectedChatAction(contact));
              openChat(contact);
            }
          });

          // if (callerInfo !== null) {
          //   setCaller((prev) => ({
          //     ...prev,
          //     name: callerInfo,
          //   }));
          // } else {
          setSender(message?.to);
          setReceiver(message?.from);
          // }

          console.log("offer successfully!", message);
          setIncomingCall(true);
        } else {
          console.log("nott successfully!", message);
        }
      });

      // Answering the coming Offer
      socketRef.current.on("answer", handleCallAccepted);

      socketRef.current.on("icedata", (message) => {
        if (message?.to == userId) {
          console.log("iceData Received", message);
          const iceCandidate = new RTCIceCandidate(message?.candidate);
          setComingCandidateArray([...comingCandidateArray, iceCandidate]);
        }

        // pc.current.addIceCandidate(new RTCIceCandidate(message?.candidate));
      });

      socketRef.current.on("disconnectcall", (message) => {
        setIsInCall(false);

        const concatenatedReceiverSender = message.from + "." + message?.to;
        const concatenatedSenderReceiver = message?.to + "." + message.from;

        contacts?.forEach((contact) => {
          if (
            contact?.conversationId == concatenatedSenderReceiver ||
            contact?.conversationId == concatenatedReceiverSender
          ) {
            if (contact.status !== "blocked") {
              setIncomingCall(false);
              console.log("call declined successfully!", message);
              isInCall
                ? callResponse("success", message.reason)
                : callResponse("error", message.reason);
              // setChatting(true);
            }
            callEndCall(caller);
          }
        });
      });

      socketRef.current.on("callStatusNotification", (message) => {
        console.log("CallStatusNotification", message);
        setIsInCall(false);
        setIncomingCall(false);
        callResponse("success", message.callStatusType);
        callEndCall(caller);
      });

      socketRef.current.on("notification", (message) => {
        console.log("DATA>>>CONTA");
        setContactsRefresh(true);
      });

      socketRef.current.on("contacts_list", () => {
        console.log("DATA>>>CONTA");
        setContactsSwitch((prev) => !prev);
      });

      socketRef.current.on("isBusy", (message) => {
        console.log("DATA>>>CONTA2");
        if (message?.to == userId) {
          setUserBusy(true);
          setTimeout(() => {
            setCall({ audio: false, video: false });
          }, 2000);
        }

        // pc.current.addIceCandidate(new RTCIceCandidate(message?.candidate));
      });
    }
    return () => {
      if (socketRef.current) {
        console.log("listeners cleanup");
        socketRef.current.off("new-contact-request");
        socketRef.current.off("contactDelete");
        // socketRef.current.off("online-users");
        socketRef.current.off("switchContent");
        socketRef.current.off("offer");
        socketRef.current.off("answer", handleCallAccepted);
        socketRef.current.off("icedata");
        socketRef.current.off("disconnectcall");
        socketRef.current.off("contactslist2");
        socketRef.current.off("isBusy");
        socketRef.current.off("online-users");
        socketRef.current.off("callStatusNotification");
        socketRef.current.off("prv_typing_message");
      }
    };
  }, [isConnected]);

  // useEffect(() => {
  //   socketRef?.current?.on("offer", (message) => {
  //     console.log("offerReceived", message);
  //   });
  // }, []);

  // Fetch User Data and update User State

  useEffect(() => {
    console.log(">>>selectedChat???", selectedChat);
    if (!selectedChat) dispatch(chatOpenAction(false));
    let isUpdated = false;
    const alterConversationId = selectedChat?.conversationId
      .split(".")
      .reverse()
      .join(".");
    alterConversationId &&
      apiServices
        .filterContact(null, null, alterConversationId)
        .then((data) => {
          console.log("DATA_FOUND_FOR_CHAT", data);
          const newData = data?.data?.[0];
          if (!isUpdated && newData?.status === "blocked") {
            isUpdated = true;
            setSelectedChatBlocked(true);
          }
          console.log("updatedSelectedChat?", selectedChat);
        });

    return () => {
      // Cleanup function
      isUpdated = false; // Reset the updated flag
      console.log("Cleanup for useEffect executed");
    };
  }, [selectedChat]);

  //  Call will end after 45 seconds ringing
  // useEffect(() => {
  //   isInCallRef.current = isInCall;
  //   isInCall &&
  //     setTimeout(() => {
  //       console.log("call check?");
  //       if (!isRemoteSet && isInCallRef.current) {
  //         console.log("call check2?");
  //         socketRef.current.emit("disconnectcall", {
  //           from: sender,
  //           to: receiver,
  //           reason: "Call Not Responded",
  //         });
  //         setIsInCall(false);
  //         callEndCall(caller);
  //       }
  //     }, 30000);
  // }, [isInCall]);

  // useEffect(() => {
  //   // Check if the new path is different from the previous path
  //   if (location.pathname === previousPathRef.current) {
  //     // Perform actions or reload the window
  //     window.location.reload();
  //   }

  //   // Update the previousPathRef with the current path
  //   previousPathRef.current = location.pathname;

  //   return () => {
  //     // Clean-up logic if needed
  //     // This function will be called when the component unmounts or when 'third' changes
  //   };
  // }, [location.pathname]);

  const memoizedUserIdsArray = useMemo(() => userIdsArray, [userIdsArray]);
  // console.log("MEMO_ONLINE>>>",memoizedUserIdsArray);

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleSnackbarClose = () => {
    setSnackbarState({
      message: "",
      severity: "",
      open: false,
    });
  };

  const callResponse = (severity, message) => {
    setSnackbarState({
      message: message,
      severity: severity,
      open: true,
    });
  };

  const handleButtonClick = (buttonId) => {
    // Implement your logic here
    setActiveButton(buttonId);
  };

  // const handleRefresh = () => {
  //   if (friendRequest) {
  //     const userData = JSON.parse(localStorage.getItem("user"));

  //     setLoader(true);
  //     callFilterApi(userData?.id);
  //   } else if (!friendRequest) {
  //     getContacts();
  //   }
  // };

  function isCameraOn() {
    return new Promise((resolve, reject) => {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          const videoDevices = devices.filter(
            (device) => device.kind === "videoinput"
          );
          const isCameraOn = videoDevices.length > 0;
          resolve(isCameraOn);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // INITIALIZED RTCPeerConnection function
  const initializedRTCPeerConnection = () => {
    const configuration = {
      iceServers: [
        {
          urls: "turn:relay1.expressturn.com:3478",
          credential: "SR1UhlN9lSYWGgtf",
          username: "ef5RT8MBFW9C88AHJH",
        },
        {
          urls: "turn:numb.viagenie.ca",
          credential: "muazkh",
          username: "webrtc@live.com",
        },
        {
          urls: "turn:192.158.29.39:3478?transport=udp",
          credential: "JZEOEt2V3Qb0y27GRntt2u2PAYA=",
          username: "28224511:1379330808",
        },
        {
          urls: "turn:192.158.29.39:3478?transport=tcp",
          credential: "JZEOEt2V3Qb0y27GRntt2u2PAYA=",
          username: "28224511:1379330808",
        },
        {
          urls: "turn:turn.bistri.com:80",
          credential: "homeo",
          username: "homeo",
        },
        {
          urls: "turn:turn.anyfirewall.com:443?transport=tcp",
          credential: "webrtc",
          username: "webrtc",
        },

        {
          urls: "stun:stun.l.google.com:19302", // Example STUN server provided by Google
        },
        {
          urls: "stun:stun1.l.google.com:19302", // Another Google STUN server
        },
        {
          urls: "stun:stun.relay.metered.ca:80",
        },
        {
          urls: "turn:global.relay.metered.ca:80",
          username: "cc8f814db4fef426b5b5134a",
          credential: "XcQ2IIf5AtlDzfr4",
        },
        {
          urls: "turn:global.relay.metered.ca:80?transport=tcp",
          username: "cc8f814db4fef426b5b5134a",
          credential: "XcQ2IIf5AtlDzfr4",
        },
        {
          urls: "turn:global.relay.metered.ca:443",
          username: "cc8f814db4fef426b5b5134a",
          credential: "XcQ2IIf5AtlDzfr4",
        },
        {
          urls: "turns:global.relay.metered.ca:443?transport=tcp",
          username: "cc8f814db4fef426b5b5134a",
          credential: "XcQ2IIf5AtlDzfr4",
        },
      ],
      audioProcessing: {
        echoCancellation: true,
        noiseSuppression: true,
        // Other audio processing options
      },
    };
    if (!pc.current) {
      try {
        pc.current = new RTCPeerConnection(configuration);
        rtcPeerConnectionCount++;
        console.log(
          "RTC Peer Connection created. Total count:",
          rtcPeerConnectionCount
        );
        // _pcRef.current = _pc;
        // Use _pc for your tasks
      } catch (error) {
        // Handle the error gracefully
        console.error("Error creating RTCPeerConnection:", error);
        // Optionally, you can set _pc to null or perform additional actions based on the error
      }
      pc.current.onicecandidateerror = (e) => {
        console.log(e, "onicecandidateerror");
      };

      pc.current.onicegatheringstatechange = () => {
        console.log(pc.current.iceGatheringState, "onicegatheringstatechange");
      };

      pc.current.onsignalingstatechange = () => {
        console.log("Signaling state:", pc.current.signalingState);
      };
      // Assuming _pc is your RTCPeerConnection instance
      pc.current.onconnectionstatechange = (event) => {
        console.log("ONCONNECTIONSTATECHANGE>>>>", event);
        const connectionState = pc.current.connectionState;

        if (connectionState === "connected") {
          console.log("User is in a call.CONNECTION_STATE>>>", connectionState);
          // localStorage.setItem('isInCall', 'true');
          // Update your UI or perform other actions as needed
        } else if (
          connectionState === "disconnected" ||
          connectionState === "failed"
          // connectionState === "closed"
        ) {
          callEndCall();
          console.log("User is not in a call.");

          // localStorage.removeItem('isInCall');
          // Update your UI or perform other actions as needed
        }
      };

      // _pc.onconnectionstatechange = (e) => {
      //   console.log("connectionState", e);
      //
      // };
      pc.current.oniceconnectionstatechange = (e) => {
        console.log("oniceconnectionstatechange", e);
      };

      pc.current.ontrack = (e) => {
        console.log("ontrackkkkkkk", e);
        remoteVidRef.current.srcObject = e.streams[0];
      };
      // setCallEnded(false);
      console.log("PEER_CONNECTION_INSTANCE>>>", pc.current);
      // pc.current = _pc;
    }
  };

  const callNavigator = (type) => {
    return new Promise((resolve, reject) => {
      let constraints = {
        audio: true,
        video: true,
      };

      // if (caller?.type === "audio" || caller.hasVideo == "false") {
      //   constraints = {
      //     audio: true,
      //     video: false,
      //   };
      // } else {
      //   constraints = {
      //     audio: true,
      //     video: true,
      //   };
      // }
      try {
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then((stream) => {
            // Assuming localVidRef and pc are accessible
            localVidRef.current.srcObject = stream;
            console.log("LOCALVIDREF1>>>>>", localVidRef);
            stream?.getTracks()?.forEach((track) => {
              pc.current.addTrack(track, stream);
            });
            console.log("Stream Get1", stream);
            // if (!caller.hasVideo) {
            //   console.log("stream", stream.getVideoTracks());
            //   stream.getVideoTracks().forEach((track) => {
            //     console.log(track)
            //     track.enabled = false;
            //   });
            // }
            resolve(); // Resolving the Promise once the operation is successful
          })
          .catch((e) => {
            console.error("Error accessing camera or microphone:,........", e);
            console.error(
              "Error accessing camera or caller:,........",
              caller?.callRec
            );
            socketRef.current.emit("disconnectcall", {
              from: caller?.callRec,
              to: caller?.callSender,
              reason: "Error Accessing Device",
              deviceId: otherCallerDeviceId,
            });
            // callEndCall(caller);
            reject(e); // Rejecting the Promise if there's an error
          });
      } catch (err) {
        console.log("Error accessing device", err);
        callResponse("error", err.message);
      }
    });
  };

  const createOffer = (type, platform = "web") => {
    try {
      if (type === "videoSwitch") {
        setVideoSwitch(true);
        socketRef.current.emit("switchContent", {
          from: sender,
          to: receiver,
        });
      }
      const constraints = {};
      // if (type === "audio") {
      //   constraints.audio = true;
      //   constraints.video = false;
      // } else {
      // type === "video" here value of
      constraints.audio = true;
      constraints.video = true;
      // }
      console.log("constraints", constraints);
      checkMediaDevicesAndPermissions()
        .then((data) => console.log("permissionCheck???", data))
        .catch((err) => console.log(err));
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          localVidRef.current.srcObject = stream;
          stream?.getTracks()?.forEach((track) => {
            pc.current.addTrack(track, stream);
          });

          // Once the media stream is obtained, create the offer
          const offer = pc.current.createOffer();

          type === "audio" &&
            localVidRef.current.srcObject
              .getVideoTracks()
              .forEach((track) => track.stop());
          return offer;
        })
        // pc.current.createOffer()
        .then((sdp) => {
          console.log(JSON.stringify(sdp));
          pc.current.onicecandidate = storeIceCandidate;
          pc.current.setLocalDescription(sdp);
          if (platform === "web" || type === "videoSwitch") {
            socketRef.current.emit(
              "offer",
              {
                from: sender.toString(),
                to: receiver,
                offer: sdp,
                hasVideo: type !== "audio" ? true : false,
                type: type,
                platform: "web",
                deviceId,
              },
              (res) => console.log("res is", res)
            );
          }

          setOutgoingCall(true);
          console.log("Offer created successfully");
        })
        .catch((error) => {
          alert(
            "You have denied permissions for the camera & mic. Please enable access."
          );
          // callEndCall();
          console.log("Error creating offer:", error);
        });
    } catch (error) {
      console.log("Error creating offer2:", error);
      callResponse("error", error.message);
    }
  };

  const createAnswer = () => {
    pc.current
      .createAnswer()
      .then((sdp) => {
        if (!caller.hasVideo) {
          localVidRef.current.srcObject
            .getVideoTracks()
            .forEach((track) => track.stop());
          //   //   console.log("local track disabled", caller.hasVideo);
          //   //   const senders = pc.current.getSenders();
          //   //   senders.forEach((sender) => {
          //   //     if (sender.track.kind === "video") {
          //   //       sender.track.enabled = true; // Enable the video track when switching to video call
          //   //       console.log("Video track enabled.");
          //   //     }
          //   //   });
        }
        console.log("Remote description set successfully");
        pc.current.setLocalDescription(sdp);
        console.log(
          "Remote emit on deviceId",
          otherCallerDeviceId,
          "from>",
          deviceId
        );
        socketRef.current.emit("answer", {
          to: caller.id,
          answer: sdp,
          from: caller?.callRec,
          deviceId: otherCallerDeviceId,
          fromDeviceId: deviceId,
        });
        pc.current.onicecandidate = handleIceCandidate;
        setCallAccepted((prev) => ({
          ...prev,
          accepted: true,
        }));
      })
      .catch((error) => {
        console.error("Error setting remote description:", error);
      });
  };

  const handleCallUser = useCallback(
    async (type, platform) => {
      // setCallEnded(true);
      // if(pc.current?.connectedState !== 'connected'){
      initializedRTCPeerConnection();
      console.log("PC_CURRENT_STATE?", pc.current);
      // }
      if (type === "audio") {
        setCall({ audio: true, video: false });
        setCamOff((prev) => ({ ...prev, my: false, other: false }));
      } else {
        setCall({ audio: true, video: true });
        setCamOff((prev) => ({ ...prev, my: true, other: false }));
      }

      createOffer(type, platform);
      setIsInCall(true);
      dispatch(setCallUserAction(selectedChat));
    },
    [socketRef.current, sender, receiver]
  );

  useEffect(() => {
    if (handleCall.type) {
      handleCallUser(handleCall.type, "web");
    }
  }, [handleCall?.type]);

  const handleIncomingCall = useCallback(async () => {
    console.log("INCOMINGCALL", caller);
    pc.current
      .setRemoteDescription(caller?.offer)
      .then(() => {
        setIsRemoteSet(true);
        createAnswer();
      })
      .catch((error) => {
        console.error("Error setting remote description:", error);
      });
  }, [socketRef.current, caller]);

  const handleCallAccepted = useCallback(
    async ({ from, answer, to, fromDeviceId }) => {
      console.log("listening answer>>>", {
        from,
        answer,
        to,
        fromDeviceId,
      });
      if (caller?.name == null) {
        setCamOff((prev) => ({ ...prev, other: true, my: true }));
      }
      console.log("otherCallerDeviceIdAnswerReceived", fromDeviceId);
      setOtherCallerDeviceId(fromDeviceId);
      setOutgoingCall(false);
      if (!callAccepted.accepted) {
        setCallAccepted((prev) => ({
          ...prev,
          accepted: true,
        }));
      }
      // if (sender === to && receiver === from) {
      pc?.current?.setRemoteDescription(answer);
      setIsRemoteSet(true);
      setIsInCall(true);

      console.log(
        "candidateArrayRef.current.length",
        candidateArrayRef.current.length
      );
      if (candidateArrayRef.current.length > 0) {
        console.log("sending ice candidate", candidateArrayRef.current);
        console.log(
          "iceotherCallerDeviceIdAnswerReceived",
          otherCallerDeviceId
        );
        candidateArrayRef.current.forEach((candidate) => {
          socketRef.current.emit("ice", {
            ...candidate,
            deviceId: fromDeviceId,
          });
        });

        // Once candidates are added, clear the stored array
        candidateArrayRef.current = [];
      }
      // }
    },
    [callAccepted.accepted, sender, receiver]
  );

  const acceptCall = () => {
    setVideoSwitch(false);
    setIsInCall(true);
    setIncomingCall(false);
    if (caller?.type == "audio" || caller.hasVideo == "false") {
      setCall({
        video: false,
        audio: true,
      });
      setCamOff((prev) => ({ ...prev, my: false, other: false }));
    } else {
      // socketRef.current.emit("switchContent", {
      //   from: sender,
      //   to: receiver,
      //   type: "accepted",
      //   queryType: "requesting"
      // });
      setCamOff((prev) => ({ ...prev, my: true, other: true }));
      setCall({
        video: true,
        audio: true,
      });
    }
    callNavigator()
      .then(() => {
        setIsInCall(true);
        return handleIncomingCall();
      })
      .then(() => {
        // Code to execute after handleIncomingCall() finishes
      })
      .catch((error) => {
        console.error("Error handling incoming call:", error);
        // Handle errors related to handleIncomingCall()
      });
    const apiPayload = {
      from: userId.toString(),
      deviceId,
      otherUserId: receiver,
    };
    apiServices
      .sendCallAccept(apiPayload)
      .then((response) =>
        console.log("ACCEPT_CALL API CALLED", "\n", response)
      );
  };

  const declineCall = () => {
    callEndCall(caller);
    if (videoSwitch) {
      setIsInCall(false);
      setIncomingCall(false);
      setVideoSwitch(false);
    } else {
      setIsInCall(false);
      socketRef.current.emit("disconnectcall", {
        from: caller?.callRec,
        to: caller?.callSender,
        reason: "Call Decline",
        deviceId: otherCallerDeviceId,
      });

      setIncomingCall(false);
      const apiPayload = {
        from: userId.toString(),
        fromDeviceId: deviceId,
        otherUserId: caller.callSender,
        toDeviceId: otherCallerDeviceId,
      };
      apiServices
        .sendCallDecline(apiPayload)
        .then((response) =>
          console.log("<<< DECLINE_CALL API CALLED >>>", "\n", response)
        );
    }
  };

  function truncateText(text, maxLength) {
    if (text && text.length > maxLength) {
      return text.slice(0, maxLength) + "...";
    }
    return text;
  }
  const handleClose = () => {
    setAnchorEl(null);
  };

  const openChat = (chat) => {
    if (chat?.status === "blocked" && !popUpBlockDelete) {
      setPopupBlock(true);
      setBlockStatus(true);
    } else {
      setBlockStatus(false);
    }

    //
    // let senderId;
    // let receiverId;
    // if (userId == chat?.contacts[0].userId) {
    //   senderId = chat?.contacts[0].userId;
    //   receiverId = chat?.contacts[1].userId;
    // } else if (userId ==chat?.contacts[1].userId) {
    //   senderId = chat?.contacts[1].userId;
    //   receiverId = chat?.contacts[0].userId;
    // }

    const [senderId, receiverId] = chat?.conversationId
      .split(".")
      .map((part) => part.trim());
    if (
      senderId != userId &&
      chat?.requestedBy == userId &&
      chat?.status == "pending"
    ) {
      setPopup(true);
      setAccept((prev) => ({
        ...prev,
        conversationId: chat?.conversationId,
        requestedBy: chat?.requestedBy,
      }));
    }
    dispatch(chatOpenAction(true));
    // localStorage.setItem('selectedChat', JSON.stringify(chat));
    // setSelectedChat(chat);
    const payload = { ...chat };
    dispatch(selectedChatAction(payload));
    // Set the sender and receiver states
    setSender(userId);
    setReceiver(userId === receiverId ? senderId : receiverId);
    setHasMounted(false);
  };

  const handleAcceptAddContact = async (message) => {
    setPopupAdd(false);
    setAcceptAddContact(!acceptAddContact); //
  };

  const storeIceCandidate = (e) => {
    if (e.candidate) {
      console.log("listCandidates", candidateArrayRef.current);
      candidateArrayRef.current = [
        ...candidateArrayRef.current,
        {
          type: "candidate",
          from: sender ? sender : caller?.callRec,
          to: receiver ? receiver : caller?.callSender,
          candidate: e.candidate,
        },
      ];
      console.log("candidates_gathering>>>", candidateArrayRef.current);
    }
  };

  const handleIceCandidate = (e) => {
    if (e?.candidate) {
      console.log("iceOtherCallerDeviceId", otherCallerDeviceId);
      socketRef.current.emit("ice", {
        type: "candidate",
        from: sender ? sender : caller?.callRec,
        to: receiver ? receiver : caller?.callSender,
        candidate: e.candidate,
        deviceId: otherCallerDeviceId,
      });
    }
  };

  // ----------------------------------------------- HOOKS --------------------------------------------

  useEffect(() => {
    if (isRemoteSet && comingCandidateArray.length) {
      comingCandidateArray.forEach((candidate) => {
        pc.current?.addIceCandidate(candidate);
      });
      setComingCandidateArray([]);
    }
  }, [comingCandidateArray, isRemoteSet]);

  // Update Online Users into list - should be handle in event base instead interval
  // useEffect(() => {
  //   // socketRef.current.on('online')
  //   const updateUserIdsFromLocalStorage = () => {
  //     const updatedUserIdsArray =
  //       JSON.parse(localStorage.getItem("userIdsArray")) || [];
  //     setUserIdsArray(updatedUserIdsArray);
  //   };

  //   // Initial call to update the state
  //   updateUserIdsFromLocalStorage();

  //   // Set interval to update the state every 5 seconds
  //   const interval = setInterval(() => {
  //     updateUserIdsFromLocalStorage();
  //   }, 5000); // 5000 milliseconds = 5 seconds

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);

  useEffect(() => {
    audioElementRef.current = new Audio("/BuzzCom/sound/marimba_soft.mp3");
    const audioElement = audioElementRef.current;
    const handleAudioError = (e) => {
      console.error("Audio Error:", e.message);
    };

    // Add error event listener
    audioElement.addEventListener("error", handleAudioError);
    if (outgoingCall) {
      try {
        audioElement.loop = true;
        audioElement.play();
      } catch (error) {
        console.error("Error playing the ringtone:", error);
      }
    } else {
      try {
        audioElement.pause();
        audioElement.currentTime = 0;
        audioElement.removeEventListener("error", handleAudioError);
      } catch (error) {
        console.error("Error pausing the ringtone:", error);
      }
    }

    return () => {
      // Clean up - stop and remove event listeners
      if (audioElement) {
        audioElement.pause();
        audioElement.currentTime = 0;
        audioElement.removeEventListener("error", handleAudioError);
      }
    };
  }, [outgoingCall]);

  useEffect(() => {
    audioElementRef.current = new Audio("/BuzzCom/sound/marimba_soft.mp3");
    const audioElement = audioElementRef.current;
    const handleAudioError = (e) => {
      console.error("Audio Error:", e.message);
    };

    // Add error event listener
    audioElement.addEventListener("error", handleAudioError);
    const playAudio = () => {
      try {
        if (audioElement) {
          audioElement.loop = true; // Make the audio loop for continuous ringing
          audioElement.play().catch((error) => {
            console.error("Audio playback failed:", error);
          });
        }
      } catch (err) {
        console.log("Audio Ringtone playback failed:", err);
      }
    };

    const pauseAudio = () => {
      try {
        if (audioElement) {
          audioElement.pause();
          audioElement.currentTime = 0; // Reset the audio to the beginning
        }
      } catch (err) {
        console.log(err);
      }
    };
    try {
      // Event handler for user interaction triggering audio playback
      if (incomingCall) {
        playAudio();
      } else {
        pauseAudio();
      }

      // Attach the event listener to a user-triggered event (e.g., click, touch, etc.)
      document.addEventListener("click", pauseAudio);
      // Clean up - remove event listener and stop audio
    } catch (err) {
      console.log("audio play error:", err);
    }
    return () => {
      document.removeEventListener("click", pauseAudio);
      pauseAudio();
    };
  }, [incomingCall]);

  // useEffect(() => {
  //   if (useRef.current?.connected) setIsConnected(true);
  // }, [useRef.current]);

  useEffect(() => {
    console.log("userIdContacts", userId);
    console.log("popUpContacts", popUp);
    console.log("handleContacts", contactsSwitch);
    console.log("chattingContacts", chatting);
    const payload = {
      requestedBy: localStorage.getItem("userId"),
      // userName: userName,
    };
    dispatch(fetchContactsRequest(payload));
    return () => {};
  }, [
    // chatting,
    // userId,
    // userName,
    //  popUp,
    // isConnected,
    // trueIdsArray,
    // selectedChat,
    contactsSwitch,
    contactsRefresh,
  ]);

  const handleUnblock = async (message) => {
    let obj = {};
    if (message?.status == "accepted") {
      setBlockStatus(false);
    }
    if (message) {
      obj = {
        conversationId: message?.conversationId,
        requestedBy: message?.requestedBy,
        isBlocked: message?.status == "accepted" ? true : false,
      };
    } else {
      obj = {
        conversationId: selectedChat?.conversationId,
        requestedBy: selectedChat?.requestedBy,
        isBlocked: selectedChat?.status == "accepted" ? true : false,
      };
    }

    let response = await apiServices.blockContact(obj);
    if (response?.status === 200) {
      setChatting(true);
      dispatch(
        setSnackbarAction({
          status: "success",
          show: true,
          message: response?.data?.message,
        })
      );
      dispatch(selectedChatAction({ ...selectedChat, status: "accepted" }));
      setContactsSwitch(!contactsSwitch);
    } else {
      dispatch(
        setSnackbarAction({
          status: "error",
          show: true,
          message: response?.data?.message,
        })
      );
      // callResponse("error", response?.response?.data?.message);
      // alert(response?.response?.data?.message);
    }
    setPopupBlock(false);
  };

  const onLogoClick = () => {
    setAddFriendClick(false);
    setManageRequestClicked(false);
    if (width < 768) {
      setIsView(true);
    }
  };

  const onManageButtonClick = () => {
    setManageRequestClicked(true);
    setAddFriendClick(false);
  };

  const onAddFriendButtonClick = () => {
    setAddFriendClick(true);
    setManageRequestClicked(false);
  };

  const handleDeviceCallStatus = async () => {
    try {
      const res = await axiosInstance.get("/user/deviceById", {
        params: {
          deviceId: localStorage.getItem("deviceId"),
        },
      });
      if (res.data.code === 0) {
        if (!isInCall && res.data.data.callStatus !== "AVAILABLE") {
          callEndCall(caller);
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    handleDeviceCallStatus();
  }, []);

  console.log("isInCall ok", isInCall);
  // callEndCall
  console.log("endft", caller);

  return (
    <div
      className="buzzcomScreen"
      style={{
        p: 3,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <SideBarHeader alluserdata={alluserdata} callAccepted={callAccepted} />
      <div
        className={`subHeader`}
        style={{
          paddingRight: "15px",
          position: "fixed",
          width: "100%",
          background: "white",
          top: "2.5rem",
          zIndex: 99999999,
        }}
      >
        <div className="Header1">
          <AddHeaderText
            onLogoClick={onLogoClick}
            presentScreen={presentScreen}
          />
        </div>
        <div className="d-flex justify-content-end gap-2">
          <AddFriendButton onButtonClick={onAddFriendButtonClick} />
          <AddManageButton onButtonClick={onManageButtonClick} />
        </div>
      </div>
      <div className="layout-contact-messages" style={{}}>
        {/* <div className="sideNav">
          <BuzzSideNav />
        </div> */}
        <div className="message-screen row gap-3">
          <div
            className={`leftDiv col-md-4 px-0 ${
              !isView && "d-none d-md-block"
            }`}
            style={{ overflowY: chatClickedInCall ? "hidden" : "auto" }}
          >
            {manageRequestClicked ? (
              <ManageFriendRequests />
            ) : addFriendClick ? (
              <AddFriend
                setSnackbarState={setSnackbarState}
                setPopupAdd={setPopupAdd}
                acceptAddContact={acceptAddContact}
                addedContactIds={addedContactIds}
                setAddedContactIds={setAddedContactIds}
                selectedChat={selectedChat}
                memoizedUserIdsArray={memoizedUserIdsArray}
              />
            ) : isInCall && chatClickedInCall ? (
              <ChatComponent
                // setContacts={setContacts}
                blockStatus={blockStatus}
                popUpBlock={popUpBlock}
                deviceToken={deviceToken}
                camOff={camOff}
                setCamOff={setCamOff}
                callResponse={callResponse}
                setVideoSwitch={setVideoSwitch}
                userIdsArray={memoizedUserIdsArray}
                contacts={contacts}
                caller={caller}
                trueIdsArray={trueIdsArray}
                handleCallUser={handleCallUser}
                call={call}
                isInCall={isInCall}
                setCall={setCall}
                platformCall={platformCall}
                setPlatformCall={setPlatformCall}
                accept={accept}
                popUp={popUp}
                setPopup={setPopup}
                setChattingContactApi={setChatting}
                hasMounted={hasMounted}
                setHasMounted={setHasMounted}
                contactsSwitch={contactsSwitch}
                setContactsSwitch={setContactsSwitch}
                selectedChat={selectedChat}
                sender={sender}
                receiver={receiver}
                selectedChatBlocked={selectedChatBlocked}
              />
            ) : loader ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </Box>
            ) : contacts?.length > 0 ? (
              contacts?.map((contact, index) => (
                <Grid
                  item
                  container
                  xs={12}
                  sx={{
                    borderBottom: "1px solid #e4e4e4",
                  }}
                  style={{
                    background: "white",
                    padding: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                  key={contact._id}
                  className={`message ${
                    selectedChat && selectedChat._id == contact._id
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => {
                    openChat(contact);
                    if (width < 768) {
                      setIsView(false);
                    }
                    isInCall && dispatch(chatClickedInCallAction(true));
                  }}
                >
                  <Grid item className="d-flex align-items-center">
                    <Stack direction="row" spacing={2}>
                      <StatusBadge
                        contact={contact}
                        memoizedUserIdsArray={memoizedUserIdsArray}
                        right="-12px"
                        bottom="-0.5px"
                      />
                    </Stack>
                    &nbsp; &nbsp;
                    <Grid
                      item
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        marginBottom: " -4px ",
                      }}
                    >
                      <Grid className="message-info">
                        <p
                          style={{
                            position: "relative",
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "black",
                            fontFamily: "",
                          }}
                        >
                          {contact?.contacts[1].name}
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#797C7B",
                          }}
                        >
                          {truncateText(
                            contact?.lastMessageType === "6"
                              ? "Attachment"
                              : contact?.lastMessage,
                            20
                          )}
                        </p>
                      </Grid>
                    </Grid>
                    {/* <Grid
                                    className="message-info"
                                    style={{
                                      textAlign: "right",
                                      marginRight: "10px",
                                    }}
                                  ></Grid> */}
                  </Grid>
                  <Grid item xs={2.5}>
                    <p
                      style={{
                        // width: "30px",
                        // height: "12px",
                        fontFamily: "Roboto",
                        fontSize: "10px",
                        fontWeight: "400",
                        color: "#494949",
                        marginBottom: 0,
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                      }}
                    >
                      {selectedChat?.conversationId !==
                        contact?.conversationId &&
                      contact?.unreadCounts >= 1 ? (
                        <CustomBadge count={4} bgcolor="#ff6500">
                          <i className="bi bi-envelope fs-3"></i>
                        </CustomBadge>
                      ) : contact?.lastMessageTime ? (
                        formatDate(contact?.lastMessageTime)
                      ) : null}
                    </p>
                    <p>
                      {" "}
                      {contact?.status == "blocked" && <BlockIcon />}
                      {/* <Badge
                                sx={{ mr: 1 }}
                                badgeContent={message?.counts}
                                color="primary"
                              /> */}
                    </p>
                  </Grid>
                </Grid>
              ))
            ) : (
              !searchQuery &&
              contacts?.length === 0 && (
                <>
                  <Typography
                    className="noRequests"
                    variant="h6"
                    style={{ marginTop: "20px" }}
                  >
                    No contacts
                  </Typography>
                  {/* <Button
                    sx={{
                      textTransform: "capitalize",
                      display: "block",
                      margin: "auto",
                      marginTop: "10px",
                    }}
                    onClick={() =>
                      document.getElementById("search-field").focus()
                    }
                  >
                    Add Contacts
                  </Button> */}
                </>
              )
            )}
          </div>
          <div
            className={`rightDiv col px-0 ${isView && width < 768 && "d-none"}`}
          >
            <CustomizedSnackbars
              open={snackbarState.open}
              message={snackbarState.message}
              severity={snackbarState.severity}
              onClose={handleSnackbarClose}
            />

            <AcceptRequestDialog
              cancelText="No"
              acceptText="Yes"
              title={"Add User"}
              text={`Do you want to add the User ?`}
              open={popUpAdd}
              onAccept={() => handleAcceptAddContact()}
              onClose={() => {
                // setBlockStatus(false)

                setPopupAdd(false);
              }}
            />

            <AcceptRequestDialog
              cancelText="No"
              acceptText="Yes"
              title={"User Blocked"}
              text={`Do you want to unblock the user ?`}
              open={popUpBlock}
              onAccept={() => handleUnblock(selectedChat)}
              onClose={() => {
                // setBlockStatus(false)
                dispatch(chatOpenAction(false));
                // setSelectedChat(null);
                dispatch(selectedChatAction(null));
                setPopupBlock(false);
              }}
            />

            <Snackbar />

            {call.audio || call.video ? (
              <CallComponent
                blockStatus={blockStatus}
                popUpBlock={popUpBlock}
                deviceToken={deviceToken}
                setCamOff={setCamOff}
                camOff={camOff}
                callResponse={callResponse}
                userBusy={userBusy}
                setUserBusy={setUserBusy}
                setMuteStatus={setMuteStatus}
                muteStatus={muteStatus}
                setVideoSwitch={setVideoSwitch}
                handleCallUser={handleCallUser}
                deviceId={deviceId}
                otherCallerDeviceId={otherCallerDeviceId}
                userIdsArray={memoizedUserIdsArray}
                contacts={contacts}
                caller={caller}
                localVidRef={localVidRef}
                remoteVidRef={remoteVidRef}
                setRemoteStream={setRemoteStream}
                remoteStream={remoteStream}
                myStream={myStream}
                callEndCall={callEndCall}
                callAccepted={callAccepted}
                setCallAccepted={setCallAccepted}
                call={call}
                setCall={setCall}
                platformCall={platformCall}
                setPlatformCall={setPlatformCall}
                accept={accept}
                popUp={popUp}
                setPopup={setPopup}
                hasMounted={hasMounted}
                setHasMounted={setHasMounted}
                selectedChat={selectedChat}
                sender={sender}
                receiver={receiver}
                setIsInCall={setIsInCall}
                isInCall={isInCall}
                setContactsSwitch={setContactsSwitch}
              />
            ) : chatOpen ? (
              <ChatComponent
                // setContacts={setContacts}
                blockStatus={blockStatus}
                popUpBlock={popUpBlock}
                deviceToken={deviceToken}
                camOff={camOff}
                setCamOff={setCamOff}
                callResponse={callResponse}
                setVideoSwitch={setVideoSwitch}
                userIdsArray={memoizedUserIdsArray}
                contacts={contacts}
                caller={caller}
                trueIdsArray={trueIdsArray}
                handleCallUser={handleCallUser}
                call={call}
                isInCall={isInCall}
                setCall={setCall}
                platformCall={platformCall}
                setPlatformCall={setPlatformCall}
                accept={accept}
                popUp={popUp}
                setPopup={setPopup}
                setChattingContactApi={setChatting}
                hasMounted={hasMounted}
                setHasMounted={setHasMounted}
                selectedChat={selectedChat}
                sender={sender}
                receiver={receiver}
                selectedChatBlocked={selectedChatBlocked}
              />
            ) : (
              <div className="p-3 d-md-block d-none">
                <Typography
                  className="welcome-to"
                  variant="h3"
                  gutterBottom
                  color="primary"
                >
                  WELCOME TO BUZZCOM!!!
                </Typography>
                <Typography variant="body1" color="gray">
                  BuzzCom is a platform that allows users to connect, chat, and
                  collaborate with each other. It features a simple and
                  intuitive interface, allowing users to easily find and
                  communicate with their friends and family.
                </Typography>
              </div>
            )}
            {/* {openContact?.contacts?.length && <ChatMain />} */}
          </div>
          {incomingCall && (
            <div className="modalBackdrop">
              <div className="containerIn">
                <div className="circleContainer">
                  <div className="imageContainerChat">
                    <Avatar
                      className="avatarSize"
                      alt="Remy Sharp"
                      src="/static/images/avatar/1.jpg"
                    >
                      {" "}
                      {caller.name ? caller.name.charAt(0) : "U"}
                    </Avatar>
                    {/* <img
                    src={process.env.PUBLIC_URL + "/BuzzCom/images/profile.png"}
                    alt="Your Image"
                    className="circleImage"
                  /> */}
                  </div>
                  <div className="ringingText">
                    {videoSwitch
                      ? `${
                          caller.name == null ? "Unknown" : caller.name
                        } is requesting to switch to video call`
                      : `${caller.name == null ? "Unknown" : caller.name} is ${
                          caller?.type
                        } calling...`}{" "}
                  </div>
                  <div className="buttonContainer">
                    <button className="acceptButton" onClick={acceptCall}>
                      Accept
                    </button>
                    <button
                      sx={{
                        ":hover": {
                          background: "tomato",
                          backgroundColor: "tomato",
                        },
                      }}
                      className="declineButton"
                      onClick={declineCall}
                    >
                      Decline
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
    // </SideNavone>
  );
};

export default MessageScreen;
